import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'Teach climate science and climate change with confidence. 6 visual teaching volumes, 5 exclusive bonuses and instant access for science, earth science, environmental science and geography teachers.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-background font-sans text-muted antialiased" data-id="element-0" data-mp="nxn71wrpjbph">
      <MetaPixel data-id="element-1" data-mp="swgkxqawp4q6" />
      <main data-id="element-2" data-mp="36859fxwiety">
        <Hero data-id="element-3" data-mp="35yo8huu3i0e" />
        <LookInsideCarousel data-id="element-4" data-mp="35glr3hkw7k1" />
        <ProblemSection data-id="element-5" data-mp="34nbhsjeuzx5" />
        <SystemSection data-id="element-6" data-mp="3uct3pkqacp10" />
        <ModulesSection data-id="element-7" data-mp="3udax89lkcp58" />
        <BonusSection data-id="element-8" data-mp="3ubzrw5cgz9c0" />
        <UrgencySection data-id="element-9" data-mp="3ucj91juaptoz" />
        <PricingSection data-id="element-10" data-mp="d4nvlgp3tk2e" />
        <GuaranteeSection data-id="element-11" data-mp="d4xobc1ja5bs" />
        <FAQ data-id="element-12" data-mp="d45rxz0443kg" />
        <ClosingSection data-id="element-13" data-mp="d3wbb20yj8rf" />
        <SummaryTable data-id="element-14" data-mp="85l1usekr09q" />
        <FinalCta data-id="element-15" data-mp="851hl51gbzsj" />
      </main>
      <Footer data-id="element-16" data-mp="864atjm8yebm" />
      <PurchaseNotification data-id="element-17" data-mp="86cqfj9r7xqi" />
    </div>;
}